import { render } from "./DisputeRequestComponent.vue?vue&type=template&id=306283c4"
import script from "./DisputeRequestComponent.vue?vue&type=script&lang=js"
export * from "./DisputeRequestComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__